import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=74baf65a&"
import script from "./order-item.vue?vue&type=script&lang=js&"
export * from "./order-item.vue?vue&type=script&lang=js&"
import style0 from "./order-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74baf65a')) {
      api.createRecord('74baf65a', component.options)
    } else {
      api.reload('74baf65a', component.options)
    }
    module.hot.accept("./order-item.vue?vue&type=template&id=74baf65a&", function () {
      api.rerender('74baf65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/order-item.vue"
export default component.exports